document.addEventListener("DOMContentLoaded", function () {

  // const splideBannerCarousel_main = '#banner_carousel';
  // const splideBannerCarousel_options = {
  //   mediaQuery: 'max',
  //   type   : 'loop',
  //   autoplay: false,
  //   perPage: 3,
  //   perMove: 1,
  //   gap: 10,
  //   speed: 1000,
  //   rewind: false,
  //   pagination: true,
  //   arrows: true,
  //   updateOnMove: true,
  //   focus: 'center',
  //   breakpoints: {
  //     640: {
  //       arrows: false,
  //       perPage: 1,
  //       padding: "5%",
  //       gap: 0,
  //     }
  //   },
  // }
  // if (document.querySelectorAll(splideBannerCarousel_main).length > 0) {
  //   const splideBannerCarousel = new Splide(splideBannerCarousel_main, splideBannerCarousel_options);
  //   splideBannerCarousel.mount();
  // }

  const splideBannerCarousel_main = '#banner_carousel';
  const splideBannerCarousel_element = document.querySelector(splideBannerCarousel_main);

  if (splideBannerCarousel_element) {
    // スライド枚数を取得
    const slideCount = splideBannerCarousel_element.querySelectorAll('.splide__slide').length;

    // 初期オプション設定
    const splideBannerCarousel_options = {
      mediaQuery: 'max',
      type: slideCount >= 4 ? 'loop' : 'slide',
      autoplay: false,
      perPage: 3,
      perMove: 1,
      gap: 10,
      speed: 1000,
      rewind: false,
      pagination: true,
      arrows: slideCount >= 4 ? true : false,
      updateOnMove: true,
      focus: slideCount >= 4 ? 'center' : '',
      breakpoints: {
        740: {
          arrows: false,
          type: slideCount >= 2 ? 'loop' : '',
          perPage: 1,
          padding: "5%",
          gap: 0,
        }
      },
    };

    // Splide の初期化とマウント
    const splideBannerCarousel = new Splide(splideBannerCarousel_main, splideBannerCarousel_options);
    splideBannerCarousel.mount();
  }


  const splideYoutubeCarousel_main = '#youtube_carousel';
  const splideYoutubeCarousel_options = {
    mediaQuery: 'max',
    type   : 'loop',
    autoplay: false,
    perPage: 2.5,
    perMove: 1,
    speed: 1000,
    gap: '20px',
    rewind: false,
    pagination: true,
    arrows: true,
    updateOnMove: true,
    focus: 'center',
    drag: true,
    fixedWidth: '800px',
    isNavigation: true,
    breakpoints: {
      740: {
        fixedWidth: '100%',
        perPage: 1,
        // padding: '10px',
        // gap: '10px',
        padding: "10%",
        gap: 10,
        arrows: true,
        updateOnMove: true,
      }
    },
  }
  if (document.querySelectorAll(splideYoutubeCarousel_main).length > 0) {
    const splideYoutubeCarousel = new Splide(splideYoutubeCarousel_main, splideYoutubeCarousel_options);
    splideYoutubeCarousel.mount();
  }

  
});